<template>
  <div class="grid grid-cols-3 items-center sm:flex sm:justify-between">
    <slot />
  </div>
</template>
